<template>
  <button
    type="button"
    class="button is-small is-success"
    :class="{
      'is-loading': isSubmitting,
      'is-success': activated,
      'is-danger': !activated
    }"
    @click="toggle"
  >
    <template v-if="activated">
      <span class="hover">{{ $t('global.actions.deactivate') }}</span>

      <span>Aktiveret</span>
    </template>

    <template v-else>
      <span class="hover">{{ $t('global.actions.activate') }}</span>

      <span>Deaktiveret</span>
    </template>
  </button>
</template>

<style lang="scss" scoped>
.button {
  span.hover {
    display: none;
  }

  &:hover {
    span {
      display: none;
    }

    span.hover {
      display: block;
    }
  }
}
</style>

<script>
import UserService from '@/taskflex/users/services/UserService'

export default {
  data () {
    return {
      isSubmitting: false,
      activated: false,
      sendActivationMail: false
    }
  },

  props: {
    user: {
      required: true
    }
  },

  mounted () {
    this.activated = this.user.activated
  },

  methods: {
    toggle () {
      if (this.activated) {
        this.deactivate()

        return
      }

      const activationMailPromise = new Promise((resolve, reject) => {
        // eslint-disable-next-line
        const rv = confirm('Vil du sende aktiverings mail til brugeren?')

        if (rv) resolve(true)
        reject()
      })

      activationMailPromise
        .then(() => {
          this.sendActivationMail = true
        })
        .catch(() => {
          this.sendActivationMail = false
        })
        .finally(() => {
          this.activate()
        })
    },

    activate () {
      this.isSubmitting = true

      UserService.activate(
        this.user.id,
        { sendActivationMail: this.sendActivationMail },
        () => {
          this.isSubmitting = false
          this.activated = true

          this.$emit('activated')
        }
      )
    },

    deactivate () {
      this.isSubmitting = true

      UserService.deactivate(this.user.id, {}, () => {
        this.isSubmitting = false
        this.activated = false

        this.$emit('deactivated')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/components/UserActivationToggleButton.vue